class TabbedCollections extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('.tabbed-collections__tab');
    this.panels = this.querySelectorAll('.tabbed-collections__panel');
    this.tabsContainer = this.querySelector('.tabbed-collections__tabs');
    this.viewAllBtn = this.querySelector('.tabbed-collections__view-all-btn');

    this.init();
  }

  init() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        this.switchTab(tab);
      });
    });

    const activeTab = this.querySelector('.tabbed-collections__tab--active');
    if (activeTab) {
      this.#scrollToTab(activeTab, 'instant');
      this.#updateViewAllLink(activeTab);
    }

    // Set all inactive panel images to lazy
    this.panels.forEach(panel => {
      if (!panel.classList.contains('tabbed-collections__panel--active')) {
        panel.querySelectorAll('img').forEach(img => {
          img.loading = 'lazy';
          img.decoding = 'async';
        });
      }
    });
  }

  #scrollToTab(selectedTab, behavior = 'smooth') {
    if (!this.tabsContainer) return;
    
    const scrollPosition = selectedTab.offsetLeft - (this.tabsContainer.offsetWidth / 2) + (selectedTab.offsetWidth / 2);
    
    this.tabsContainer.scrollTo({
      left: scrollPosition,
      behavior: behavior
    });
  }

  #updateViewAllLink(selectedTab) {
    if (!this.viewAllBtn) return;
    const url = selectedTab.dataset.collectionUrl;
    this.viewAllBtn.href = url || '#';
  }

  switchTab(selectedTab) {
    const targetId = selectedTab.dataset.tab;

    // 1. Update Tab Buttons
    this.tabs.forEach(tab => {
      const isSelected = tab === selectedTab;
      tab.classList.toggle('tabbed-collections__tab--active', isSelected);
      tab.setAttribute('aria-selected', isSelected);
    });

    // 2. Update Panels
    this.panels.forEach(panel => {
      const isActive = panel.id === `tab-panel-${targetId}`;
      panel.classList.toggle('tabbed-collections__panel--active', isActive);
    });

    // 3. Center the tab
    this.#scrollToTab(selectedTab);

    // 4. Update View All link
    this.#updateViewAllLink(selectedTab);
  }
}

if (!customElements.get('tabbed-collections')) {
  customElements.define('tabbed-collections', TabbedCollections);
}